// Refer & Earn: the code a new talent arrived with (requesta.app/join/CODE),
// remembered on this device until they finish signing up. Codes are not case
// sensitive; stored lowercase, shown in caps. Storage can be blocked
// (private mode) — then the optional field at signup is the way in.
const KEY = "referral_invite_v1";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

export const cleanReferralCode = (raw: string) =>
  String(raw || "").trim().replace(/^@+/, "").toLowerCase().slice(0, 60);

export function saveInviteCode(raw: string): void {
  const code = cleanReferralCode(raw);
  if (!code) return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ code, at: Date.now() }));
  } catch {
    /* no storage — nothing to remember */
  }
}

export function readInviteCode(): string {
  try {
    const saved = JSON.parse(window.localStorage.getItem(KEY) || "null");
    if (!saved?.code || Date.now() - Number(saved.at) > MAX_AGE_MS) return "";
    return cleanReferralCode(saved.code);
  } catch {
    return "";
  }
}

export function clearInviteCode(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* no-op */
  }
}
